import React from 'react';

import styled from 'styled-components';

import { NwEditButton } from '@components/Gui/NwButton';

import { isMainStatementLine } from '../helpers';

const Wrapper = styled.div`
    min-width: 6rem;
    min-height: 4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &.commission-row {
        min-height: 2.5rem;
        margin-top: -2px;
        background-color: white;
    }
`;

const StatementActionsCell = ({ row, onEditTransaction, preserveEmptySlot = true, variant = 'billing-search' }) => {
    if (variant === 'project-grouped' && !isMainStatementLine(row)) {
        return <Wrapper className="statement-actions commission-row">&nbsp;</Wrapper>;
    }

    if (!onEditTransaction) {
        return preserveEmptySlot ? <Wrapper className="statement-actions">&nbsp;</Wrapper> : null;
    }

    return (
        <Wrapper className="statement-actions">
            <NwEditButton
                iconOnly
                onClick={(e) => {
                    e.stopPropagation();
                    onEditTransaction(row.Transaction || row);
                }}
            />
        </Wrapper>
    );
};

export default StatementActionsCell;
